export const FUND_REQUIREMENTS = [
  { value: "10-50", label: "INR 10 Lacs to INR 50 Lacs" },
  { value: "50-100", label: "INR 50 Lacs to INR 1 Crore" },
  { value: "100-200", label: "INR 1 Crore to INR 2 Crore" },
  { value: "200-500", label: "INR 2 Crore to INR 5 Crore" },
  { value: "500+", label: "Above INR 5 Crore" },
];

export const SECURITY_OPTIONS = [
  { value: "property", label: "Property" },
  { value: "machinery", label: "Machinery" },
  { value: "fd_or_debt_mf", label: "FD or Debt MF" },
  { value: "not_available", label: "Not available" },
  { value: "other", label: "Other" },
];

export const PROFESSION_OPTIONS = [
  { value: "salaried", label: "Salaried" },
  { value: "self_employed", label: "Self Employed" },
  { value: "business_owner", label: "Business Owner" },
  { value: "professional", label: "Professional" },
  { value: "other", label: "Other" },
];

export const FUND_REQUIREMENT_OPTIONS = [
  { value: "1_5L", label: "1-5 Lakhs" },
  { value: "5_10L", label: "5-10 Lakhs" },
  { value: "10_25L", label: "10-25 Lakhs" },
  { value: "25_50L", label: "25-50 Lakhs" },
  { value: "above_50L", label: "Above 50 Lakhs" },
];

export const END_USE_OPTIONS = [
  { value: "business_expansion", label: "Business Expansion" },
  { value: "working_capital", label: "Working Capital" },
  { value: "equipment_purchase", label: "Equipment Purchase" },
  { value: "debt_consolidation", label: "Debt Consolidation" },
  { value: "other", label: "Other" },
];

export const USER_TYPES = {
  BORROWER: "borrower",
  LENDER: "lender",
  CONSULTANT: "consultant",
  ADMIN: "admin",
};

export const BORROWER_TYPES = {
  INDIVIDUAL: "individual",
  ENTITY: "entity",
};

export const ENTITY_TYPES = {
  COMPANY: "company",
  PARTNERSHIP_FIRM: "partnership_firm",
  propreitorship_firm: "propreitorship_firm",
};
